module.exports = __webpack_public_path__ + "img/20200619_160901.d34fc626.jpg";